<script setup lang="ts">
  import { useMenuStore } from '@/stores/menu'
  import { useMediaQuery } from '@vueuse/core'
  import { useRouter } from 'vue-router'

  const menu = useMenuStore()
  const router = useRouter()
  const isMobile = useMediaQuery('(max-width: 768px)')

  router.afterEach(() => isMobile.value && (menu.isOpen = false))
</script>

<template>
  <aside
    class="fixed bottom-0 top-0 md:top-0 left-0 bg-white border-r border-white-gray z-10 transition-transform duration-300 ease-in-out"
    :class="{
      'w-72': isMobile && menu.isOpen,
      'translate-x-0 w-72 md:w-navigation': !isMobile && menu.isOpen,
      '-translate-x-full w-72 md:w-navigation': !isMobile && !menu.isOpen,
    }"
  >
    <div class="absolute top-0 bottom-0 w-full left-72 bg-blue-10/30 md:hidden" @click="menu.isOpen = false"></div>
    <div
      :class="{ 'overflow-y-scroll overflow-x-visible': menu.isOpen }"
      class="absolute inset-0 flex flex-col max-md:overflow-y-scroll max-md:overflow-x-visible"
    >
      <slot></slot>
    </div>
    <div
      class="absolute cursor-pointer top-1/2 transform -translate-y-1/2 right-0 translate-x-full w-4 h-16 bg-white hover:bg-white-gray rounded-tr-xl rounded-br-xl border border-white-gray justify-center items-center hidden md:inline-flex snap-mandatory"
      role="button"
      :aria-label="menu.isOpen ? 'Hide navigation' : 'Show navigation'"
      @click="menu.toggleOpen"
    >
      <des-icon v-if="menu.isOpen" class="w-4 h-3" icon="fa-light fa-chevron-left" />
      <des-icon v-else class="w-4 h-3" icon="fa-light fa-chevron-right" />
    </div>
  </aside>
</template>
